import React, { Component } from 'react';
import { Modal } from "antd";

const { confirm } = Modal;

export default async () => {
    try {
        let open = true;
        const noRemind = ['pay', '关于千乘财务管理系统收费的通知', 'payselect', 'login'];

        const data = JSON.parse(sessionStorage.getItem('chargeNotice') || "{}");

        if (data && data.switch == 1) {
            const timer = setInterval(() => {
                const isPath = noRemind.every(x => !window.location.hash.includes(x));
                const res = open && isPath && confirm({
                    title: data.name,
                    content: <div className="home-richText" dangerouslySetInnerHTML={{ __html: data.content || "" }}></div>,
                    cancelText: "关闭",
                    okText: "查看付费详情",
                    onOk() {
                        open = true
                        window.location.href = "/#/pay"
                    },
                    onCancel() {
                        open = true
                    },
                });
                open = !isPath ? true : false;
            }, 20000)
        }
    } catch (error) {
        console.log(error);
    }

}


// WEBPACK FOOTER //
// ./src/method/remind.js